import styled from 'styled-components';
import { ORDERED_IMPACTS_BY_DIMENSION } from '../../../../../../../../../common/model/types';
import { useImpactChartContext, useImpactChartHeights } from '../../context';
import { ImpactRow } from './impact-row';
import { DimensionImpactsProps } from './types';

export function DimensionImpacts(props: DimensionImpactsProps) {
  const { dimension, svgId } = props;
  const { isExpanded, setModalImpactCode } = useImpactChartContext();
  const heights = useImpactChartHeights();
  const expanded = isExpanded(dimension);
  const opacity = expanded ? 1.0 : 0.0;
  const impacts = ORDERED_IMPACTS_BY_DIMENSION[props.dimension];
  return (
    <>
      {impacts.map((impactCode, index) => {
        const y =
          heights.dimensionRowExpanded +
          heights.impactBlockPaddingTop +
          index * (heights.impactRow + heights.impactsSpacing);
        return (
          <ImpactsGroup key={impactCode} style={{ opacity }} transform={`translate(0, ${y})`}>
            <ImpactRow
              impactIndex={index}
              onTitleClick={() => {
                setModalImpactCode(impactCode);
              }}
              svgId={svgId}
              impactCode={impactCode}
            />
          </ImpactsGroup>
        );
      })}
    </>
  );
}

const ImpactsGroup = styled.g`
  transition:
    0.12s opacity ease-in-out,
    transform 0.12s ease-in-out;
`;
